import {
  type DateRangeViewSetting,
  FormattingOperator,
  FormattingRuleOperator,
} from '@ardoq/api-types';
import { parseDate } from '@ardoq/date-time';

export const getCondition = (
  domainRange: DateRangeViewSetting | undefined
): FormattingOperator => {
  if (domainRange === undefined) {
    return FormattingRuleOperator.DATE_BETWEEN;
  }
  if (!Array.isArray(domainRange)) {
    return FormattingRuleOperator.RELATIVE_DATE;
  }
  const [start, end] = domainRange;
  if (start && !end) return FormattingRuleOperator.DATE_ON_OR_AFTER;
  if (!start && end) return FormattingRuleOperator.DATE_ON_OR_BEFORE;
  return FormattingRuleOperator.DATE_BETWEEN;
};

export const toDate = (
  value: string | Date | null | undefined
): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return value;
  return parseDate(value) ?? null;
};

export type SingleRelativeCondition =
  | FormattingRuleOperator.DATE_ON_OR_BEFORE
  | FormattingRuleOperator.DATE_ON_OR_AFTER;

export const isSingleRelativeCondition = (
  condition: FormattingOperator
): condition is SingleRelativeCondition =>
  condition === FormattingRuleOperator.DATE_ON_OR_BEFORE ||
  condition === FormattingRuleOperator.DATE_ON_OR_AFTER;

export type SingleRelativePickerProps = {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
};

export const getSingleRelativePickerProps = (
  condition: SingleRelativeCondition,
  domainRange: DateRangeViewSetting | undefined,
  onDomainRangeChange: (value: DateRangeViewSetting) => void
): SingleRelativePickerProps => {
  const [start, end] = Array.isArray(domainRange) ? domainRange : [null, null];
  const stringStart = typeof start === 'string' ? start : undefined;
  const stringEnd = typeof end === 'string' ? end : undefined;

  return condition === FormattingRuleOperator.DATE_ON_OR_BEFORE
    ? {
        value: stringEnd,
        onChange: (value: string | undefined) =>
          onDomainRangeChange([null, value ?? null]),
      }
    : {
        value: stringStart,
        onChange: (value: string | undefined) =>
          onDomainRangeChange([value ?? null, null]),
      };
};
